// extracted by mini-css-extract-plugin
module.exports = {"form":"PhotoCommentsForm_form__2m7th","textarea":"PhotoCommentsForm_textarea__cC_J6","button":"PhotoCommentsForm_button__3GASR","latir":"PhotoCommentsForm_latir__2559Q"};